var map = {
	"./basketball.webp": 1689,
	"./bti-img.webp": 1690,
	"./bti-title-cn.webp": 1691,
	"./bti-title-en.webp": 1692,
	"./cup.webp": 1693,
	"./football.webp": 1694,
	"./im-img.webp": 1695,
	"./im-title-cn.webp": 1696,
	"./im-title-en.webp": 1697,
	"./sb-img.webp": 1698,
	"./sb-title-cn.webp": 1699,
	"./sb-title-en.webp": 1700,
	"./sbo-img.webp": 1701,
	"./sbo-title-cn.webp": 1702,
	"./sbo-title-en.webp": 1703,
	"./sport-bg.webp": 1704,
	"./sport-ctg.webp": 1705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 789;